function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2.684
}, /*#__PURE__*/React.createElement("path", {
  d: "M44.709 9.033s-.924-4.962-.924-5.655c0-.692-.691-.807-1.384.116s-3.808 5.424-3.808 5.424l6.11.108z",
  fill: "#20201e",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.308 47.099c.313-2.238.74-4.371 1.261-6.4l1.673-.667-1.117-1.335a55.618 55.618 0 012.188-6.064l1.582-.448-.782-1.337a55.304 55.304 0 012.711-5.06l1.475-.296-.529-1.218a56.531 56.531 0 013.238-4.496l1.561-.171-.417-1.216a55.323 55.323 0 013.644-3.889l1.562-.087-.272-1.12c2.786-2.52 4.754-3.747 4.754-3.747l3.539 1.077s1.692-.924 3.077-1.846c0 0 .923-3.077 1.23-4.77.308-1.692 1.231-.923 1.539-.462.308.462 3.5 4.001 3.5 4.001s1.91-.262 3.27 0c2 .385 2.923 1.731 5.231 3.924 1.683 1.598 2.693 3 3.27 4.5.576 1.5-.115 1.5.115 2.885.231 1.385 6.463 11.77 7.154 13.04.694 1.268 2.365 5.151-.922 7.615-.923.693-1.617 1.039-2.193 1.27 0 0-.923-.231-1.268-.692a1.483 1.483 0 01-.109-.16c-.011-.033-.017-.033 0 0 .035.09.116.427-.238.852-.577.693-1.318.641-1.732.693-.615.077-1.73-.462-2.653-1.847-.924-1.386-1.501-1.847-2.193-2.655-.692-.807-4.511-2.594-6.001-5.077-.346-.575-1.154-.345-1.73.116-.577.462-3.809.577-5.193-1.731 0 0-.655 6.07 2.077 10.27 4.5 6.923 12.116 8.654 14.425 15.117H2.695c0-2.233.117-4.376.33-6.439l1.573-.831-1.317-1.299z",
  fill: "#20201e",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.686 12.163S7.531 27.243 7.531 54.475",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.274 39.749c-.016-.025-.016-.025 0 0z",
  fill: "none",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.84 22.626c-.384 4.308 1.616 7.385 1.693 7.654 0 0-4.847-2.5-5.31-5.808M33.53 30.276s-3.231 1.578-5.616.578",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.383 39.915s-2.155-2.77-2.771-4.04",
  fill: "none",
  stroke: "#20201e",
  strokeWidth: 0.7101327199999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.106 14.352s3.548.018 4.731 1.961c1.616 2.655-.23 3-.23 3s-1.847.579-3.116-1.153c-1.351-1.843-.23-3-.23-3l-1.15-.808zM57.303 33.914c-1.27-.346-2.077-.232-2.653.116 0 0 .576-1.732-.461-3.232-1.04-1.5-2.771-1.615-4.27-4.5M23.608 15.975l-2.19-1.39M19.108 20.936l-2.193-1.04M15.07 26.689l-2.54-1.041M11.837 33.281l-2.652-.924M9.3 41.014l-2.771-.807M7.798 48.855l-2.884-.341",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.7101327199999999
}));

function SvgBlackKnightL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default SvgBlackKnightL;